import {
  LOAD_CERTIFICATES,
  LOAD_CERTIFICATES_FAIL,
  LOAD_CERTIFICATES_SUCCESS,
  LoadCertificates,
  LoadCertificatesFail,
  LoadCertificatesSuccess
} from '../actions/hosting-certificates.action';
import {CertificatesAction} from "../actions";

export interface IHostingEntityState {
  entities: {[websiteId: number]: any};
  loading: boolean;
  loaded: boolean;
}

export interface IHostingCertificatesState {
  entities: {[websiteId: number]: IHostingEntityState};
}

export const initialState: IHostingCertificatesState = {
  entities: {}
};

export function reducer(state: IHostingCertificatesState = initialState, action: CertificatesAction): IHostingCertificatesState {
  let payload: any;

  switch (action.type) {

    case LOAD_CERTIFICATES:
      payload = (<LoadCertificates>action).payload;

      return {
        ...state,
        entities: {
          ...state.entities,
          [payload]: {
            ...state[payload],
            loading: true,
            loaded: false
          }
        }
      };

    case LOAD_CERTIFICATES_SUCCESS:
      payload = (<LoadCertificatesSuccess>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            entities: payload.entities,
            loading: false,
            loaded: true
          }
        }
      };

    case LOAD_CERTIFICATES_FAIL:
      payload = (<LoadCertificatesFail>action).payload;

      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            loading: false,
            loaded: true
          }
        }
      };

  }

  return state;
}
